<template>
  <NormalView is-verify />
</template>
<script>
import NormalView from '@/views/center-business/stock/transfer/virtual/view';
export default {
  name: 'BusinessStockVerifyVirtualView',
  components: {
    NormalView,
  },
  mixins: [],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
